import { render } from "./salarySlipDetails.vue?vue&type=template&id=a920ad80&scoped=true"
import script from "./salarySlipDetails.vue?vue&type=script&lang=js"
export * from "./salarySlipDetails.vue?vue&type=script&lang=js"

import "./salarySlipDetails.vue?vue&type=style&index=0&id=a920ad80&scoped=true&lang=css"
import "./salarySlipDetails.vue?vue&type=style&index=1&id=a920ad80&scoped=true&lang=css"
import "./salarySlipDetails.vue?vue&type=style&index=2&id=a920ad80&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a920ad80"]])

export default __exports__